import {styled} from '@mui/material/styles';
import Badge from '@mui/material/Badge';
import Avatar from '@mui/material/Avatar';
import {Box} from '@mui/material';
import {ReactNode, useState} from 'react';

const StyledBadge = styled(Badge)<any>(({theme, ...props}: any) => ({
  position: 'relative',
  height: 'fit-content',
  '& .MuiBadge-badge':
    props.isOffline || props.isOnline || props.fallbackBadge
      ? {
          backgroundColor: props.isOnline
            ? '#44b700'
            : props.fallbackBadge
              ? theme.palette.primary.main
              : '#777',
          color: props.isOnline
            ? '#44b700'
            : props.fallbackBadge
              ? theme.palette.primary.main
              : '#777',
          boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
          width: props.fallbackBadge ? 14 : 10,
          height: props.fallbackBadge ? 14 : 10,
          borderRadius: '50%',
          overflow: 'hidden',
          '&::after': props.showAnimation
            ? {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                borderRadius: '50%',
                animation: 'ripple 1.2s infinite ease-in-out',
                border: '1px solid currentColor',
                content: '""',
              }
            : props.fallbackBadge
              ? {
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  color: '#fff',
                  height: '100%',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  content: '"+"',
                }
              : {},
        }
      : {},
  '@keyframes ripple': {
    '0%': {
      transform: 'scale(.8)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(2.4)',
      opacity: 0,
    },
  },
}));
export interface BadgeProps {
  imgUrl?: string;
  isOnline?: boolean;
  isOffline?: boolean;
  showAnimation?: boolean;
  showFallbackIcon?: boolean;
  name?: string;
  sx?: any;
  children?: React.ReactNode;
  badge?: ReactNode;
  onClick?: () => void;
  // size?: 'small' | 'medium' | 'large';
}
const BadgeAvatars = ({sx, onClick, ...props}: BadgeProps) => {
  const [error, setError] = useState(!!!props.imgUrl ?? false);
  const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';
  // useEffect(() => {
  //   setError(false);
  // }, [props.imgUrl]);
  return (
    <StyledBadge
      overlap="circular"
      anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
      variant="dot"
      fallbackBadge={props.showFallbackIcon ? error : false}
      isOnline={props.isOnline}
      isOffline={props.isOffline}
      showAnimation={props.showAnimation}
      onClick={onClick}
      sx={{cursor: onClick ? 'pointer' : 'unset'}}
      // {...props}
    >
      <Avatar
        // alt={props.name || 'IIM Jobs User'}
        // sx={{bgcolor: 'primary.main'}}
        imgProps={{
          onError: () => setError(true),
          alt: 'user_img',
        }}
        sx={{
          color: '#91A4AE',
          bgcolor: '#fff',
          border: error
            ? isAppIimjobs
              ? '1px solid #49966E'
              : '1px solid #cecece'
            : '0.6px solid #7E7E7E33',
          ...sx,
          '& .MuiAvatar-img': {objectFit: 'contain'},
        }}
        src={props.imgUrl}
        {...props}
      >
        {/* {(props.name && props.name[0].toUpperCase()) ?? (
          <Typography fontSize={30} lineHeight={0}>
            <BiSolidUser />
          </Typography>
        )} */}
      </Avatar>
      {props.badge && (
        <Box sx={{position: 'absolute', bottom: -10, right: -2}}>
          {props.badge}
        </Box>
      )}
    </StyledBadge>
  );
};

export default BadgeAvatars;
